<span [ngClass]="{'_load-animate _load-active': loading}">
	<div class="_dialog-title">
		<div class="flex-grow-1 text-xl">{{ 'OAT.offers_approve-decline' | translate }}</div>
		<button mat-icon-button (click)="cancel()" class="dialog-close-button">
			<mat-icon aria-label="Close Dialog">close</mat-icon>
		</button>
	</div>

	<div class="_dialog-content border-top">
		@if (totalOrderDiscount) {
			<div class="px-2 pt-3">
				<div class="alert alert-info mb-0">
					{{ 'pay_by_items_discount' | translate: {val: (totalOrderDiscount | lcurrency)} }}
				</div>
			</div>
		}


		<mat-selection-list #list class="mat-selection-list-reverse" style="margin-bottom: 150px;">
			@for (diner of offersGB; track diner.diner) {
				<div mat-subheader style="font-size: 1.2em; margin: 6px 8px;">
					<mat-checkbox class="example-margin" [(ngModel)]="diner.selected"
								  (click)="onDinerSelect(diner, list, $event)">{{ diner.name }}
					</mat-checkbox>
				</div>
				@for (offer of diner.offers; track offer._id) {
					<mat-list-option
						style="height: auto !important; min-height: 48px;"
						[selected]="offer.selected"
						[class.list-option-selected]="offer.selected" [value]="offer"
						(click)="onOfferSelected(offer, list, $event)">
						<div style="display:flex; align-items:center" [class.list-option-selected]="offer.selected">
							<app-inline-diners [diners]="[offer._diner]" class="_shadow"></app-inline-diners>
							<span class="flex-grow-1 text-ellipsis ml-2" style="font-weight: 500">
						{{ offer.name }}
					</span>
							<span class="text-accent"
								  style="min-width: 81px; text-align: right;">{{ offer.amount | lamount }}</span>
						</div>
					</mat-list-option>
				}
			}
		</mat-selection-list>
	</div>

	<div class="_dialog-actions" style="padding:0">
		<mat-tab-group class="_headers-hidden" [selectedIndex]="tabIndex" [dynamicHeight]="false">
			<mat-tab class="">
				<div class="p-3">
					<button mat-raised-button color="accent" class="lg rounded btn-block" type="button"
						   (click)="approveAll()" [disabled]="tabIndex == 3">
					<span>{{ 'OAT.approve_all_requests' | translate }}</span>
					</button>
					<button mat-raised-button color="primary" class="lg rounded btn-block mt-2" type="button"
							(click)="declineAll()" [disabled]="tabIndex == 3">
						{{ 'OAT.decline_all_requests' | translate }}
					</button>
				</div>
			</mat-tab>
			<mat-tab class="">
				<div class="p-3">
					<button mat-raised-button color="accent" class="lg rounded btn-block" type="button"
							(click)="approveSelected()" [disabled]="tabIndex == 3">
						<span>{{ 'OAT.approve_selected_requests' | translate }}</span>
						@if (total) {
							<span class="ml-3">{{ total | lamount }}</span>
						}
					</button>
					<button mat-raised-button color="primary" class="lg rounded btn-block mt-2" type="button"
							(click)="declineSelected()" [disabled]="tabIndex == 3">
						{{ 'OAT.decline_selected_requests' | translate }}
					</button>
				</div>
			</mat-tab>
		</mat-tab-group>



	</div>
</span>
